export const existingCustomerOrgFormPath = '/customer/:id';
export const getExistingCustomerOrgFormPath = (customerOrgId: number | string) => `/customer/${customerOrgId}`;
export const withCustomerOrgFormPath = (routeName: string, customerOrgId?: number | string) => {
  if (!customerOrgId) {
    return `${existingCustomerOrgFormPath}${routeName}`;
  }
  const existingCustomerOrgFromPathWithValue = getExistingCustomerOrgFormPath(customerOrgId);
  return `${existingCustomerOrgFromPathWithValue}${routeName}`;
};
export const routes = {
  customer: '/customer',
  companyInformation: '/companyinformation',
  users: '/users',
  userGroups: '/usergroups',
  orders: '/orders',
  devices: '/devices',
};
